import { ChevronLeft, CircleHelp } from "@tamagui/lucide-icons";
import { useState } from "react";

import { useGetClinicStatusForPatient } from "@/api/generated";
import { EncounterStartType } from "@/api/generated/models";
import { Button, Logo, Separator, Text, XStack, YStack } from "@/components";
import { useNoriConversationId } from "@/hooks/conversation";
import { usePropagatedRouter } from "@/hooks/usePropagatedRouter";
import PermissionsDialog from "./video/PermissionsDialog";

type CuraiHeaderProps = {
  conversationTitle: string;
  clinicianTitle: string;
};

export default function CuraiHeader({
  conversationTitle,
  clinicianTitle,
}: CuraiHeaderProps) {
  const noriConversationId = useNoriConversationId();
  const router = usePropagatedRouter();
  const [isHelpDialogOpen, setIsHelpDialogOpen] = useState(false);

  const { data: clinicStatus } = useGetClinicStatusForPatient();
  const isVideoVisit =
    clinicStatus?.latest_visit?.type === EncounterStartType.AUDIOVISUAL &&
    clinicStatus?.latest_visit?.status === "in-progress";

  return (
    <YStack padding="$200" paddingBottom="$0">
      <XStack alignItems="center" gap="$100">
        <Button.Wrapper
          aria-label="Back to chat"
          onPress={() =>
            router.navigate(
              noriConversationId ? `/conversation/${noriConversationId}` : "/",
            )
          }
        >
          <ChevronLeft size={24} />
        </Button.Wrapper>
        <YStack flexGrow={1}>
          <Text size="$md" lineHeight="$lg" bold>
            {`Connected with ${clinicianTitle}`}
          </Text>
          <Text size="$sm" lineHeight="$md" color="$textSecondary">
            {conversationTitle}
          </Text>
        </YStack>
        {isVideoVisit && (
          <Button.Wrapper
            aria-label="Help"
            onPress={() => setIsHelpDialogOpen(true)}
          >
            <CircleHelp size={24} />
          </Button.Wrapper>
        )}
        <Logo.Only />
      </XStack>
      <Separator marginTop="$200" />
      {isVideoVisit && (
        <PermissionsDialog
          heading="Experiencing issues with your call?"
          open={isHelpDialogOpen}
          onOpenChange={setIsHelpDialogOpen}
        />
      )}
    </YStack>
  );
}
